// Generated by Framer (013b13c)
import { fontStore } from "framer";
fontStore.loadFonts(["GF;DM Sans-regular", "GF;DM Sans-700", "GF;DM Sans-700italic", "GF;DM Sans-italic"]);
export const fonts = [{
  explicitInter: true,
  fonts: [{
    family: "DM Sans",
    source: "google",
    style: "normal",
    url: "/assets/8a2b97a1c264-rP2tp2ywxg089UriI5-g4vlH9VoD8CmcqZG40F9JadbnoEwAopxhS2f3ZGMZpg.woff2",
    weight: "400"
  }, {
    family: "DM Sans",
    source: "google",
    style: "normal",
    url: "/assets/c5d358a8dbc9-rP2tp2ywxg089UriI5-g4vlH9VoD8CmcqZG40F9JadbnoEwARZthS2f3ZGMZpg.woff2",
    weight: "700"
  }, {
    family: "DM Sans",
    source: "google",
    style: "italic",
    url: "/assets/7bc50a42322f-rP2rp2ywxg089UriCZaSExd86J3t9jz86Mvy4qCRAL19DksVat9uCm32RmYJpso5.woff2",
    weight: "700"
  }, {
    family: "DM Sans",
    source: "google",
    style: "italic",
    url: "/assets/f90e6ca4b17d-rP2rp2ywxg089UriCZaSExd86J3t9jz86Mvy4qCRAL19DksVat-JDW32RmYJpso5.woff2",
    weight: "400"
  }]
}];
export const css = ['.framer-Rxqat .framer-styles-preset-zoxxdx:not(.rich-text-wrapper), .framer-Rxqat .framer-styles-preset-zoxxdx.rich-text-wrapper p { --framer-font-family: "DM Sans", "DM Sans Placeholder", sans-serif; --framer-font-family-bold: "DM Sans", "DM Sans Placeholder", sans-serif; --framer-font-family-bold-italic: "DM Sans", "DM Sans Placeholder", sans-serif; --framer-font-family-italic: "DM Sans", "DM Sans Placeholder", sans-serif; --framer-font-open-type-features: normal; --framer-font-size: 14px; --framer-font-style: normal; --framer-font-style-bold: normal; --framer-font-style-bold-italic: italic; --framer-font-style-italic: italic; --framer-font-variation-axes: normal; --framer-font-weight: 400; --framer-font-weight-bold: 700; --framer-font-weight-bold-italic: 700; --framer-font-weight-italic: 400; --framer-letter-spacing: 0px; --framer-line-height: 1.2em; --framer-paragraph-spacing: 20px; --framer-text-alignment: start; --framer-text-color: var(--token-cf4471d1-e22d-4d41-914b-0cf5122a85b2, #d5d5d5); --framer-text-decoration: none; --framer-text-stroke-color: initial; --framer-text-stroke-width: initial; --framer-text-transform: none; }'];
export const className = "framer-Rxqat";
export const __FramerMetadata__ = {
  exports: {
    css: {
      type: "variable",
      annotations: {
        framerContractVersion: "1"
      }
    },
    className: {
      type: "variable",
      annotations: {
        framerContractVersion: "1"
      }
    },
    fonts: {
      type: "variable",
      annotations: {
        framerContractVersion: "1"
      }
    },
    __FramerMetadata__: {
      type: "variable"
    }
  }
};